<template>
    <!-- 添加imei -->
    <div :class="`batch-input-device ${isHover ? (!isFocus ? 'batch-input-device-hover' : '') : ''}`">
        <div class="input-box" :style="`width: ${width}`">
            <el-input :class="`input-imei ${showAdd ? 'circular' : 'vertical'}`" :size="size" v-model="imei" :placeholder="placeholder"
                clearable @focus="focus" @clear="clear"></el-input>
            <div class="area-box" ref="area" v-show="isArea">
                <el-input ref="areaInput" :style="`width: ${width}`" type="textarea"  :size="size" resize="none"
                    :placeholder="placeholder" v-model="devices" v-number-only :rows="5" autofocus @change="onChange"
                    @focus="isFocus = true" @blur="isFocus = false"></el-input>
                <div :class="`area-bottom ${isFocus ? 'area-bottom-focus' : ''}`" v-if="isArea" :style="`width: ${width}`"
                    @mouseover="isHover = true" @mouseleave="isHover = false">
                    <div>
                        <span>{{ staticText }}：</span><span>{{ countNum
                        }}{{
    `${limit != -1 ? '/' + limit : ''} ${limit != -1 && countNum > limit
        ? $t('HT.imeiInput.limit')
        : ''
        }`
}}</span>
                    </div>
                    <div class="block-btn" v-if="!hideBtn">
                        <el-button size="small" style="marginright: 8px" @click="onCancle">{{
                            cancleText
                        }}</el-button>
                        <el-button v-if="limit != -1 && countNum > limit" size="small" type="primary" disabled>{{
                            confirmText }}</el-button>
                        <el-button v-else size="small" type="primary" @click="onSubmit">{{
                            confirmText
                        }}</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-button class="add-btn" v-if="showAdd" type="primary" @click="getEffect">{{
            $t('HT.add')
        }}</el-button>
    </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
    props: {
        value: { type: String, default: '' },
        placeholder: { type: String, default: i18n.t('Common.AddImei.InputImei') },
        confirmText: { type: String, default: '确定' },
        cancleText: { type: String, default: '取消' },
        staticText: { type: String, default: '总数' },
        addbtnName: { type: String, default: '新增' },
        width: { type: String, default: '100%' },
        showAdd: { type: Boolean, default: true },
        hideBtn: { type: Boolean, default: true },
        limit: { type: Number, default: -1 },
        size: { size: String, default: 'small' },
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    data() {
        return {
            imei: this.value,
            devices: this.value,
            isArea: false,
            isFocus: false,
            isHover: false,
        }
    },
    computed: {
        countNum() {
            let imeis = this.devices.split(/\n/)
            let num = 0
            imeis.forEach((item) => {
                let str = item.replace(/\s*/g, '')
                if (str.length !== 0) {
                    num++
                }
            })
            return num
        },
    },
    watch: {
        devices(val) {
            this.$nextTick(() => {
                this.devices = val.replace(/[^\r\n0-9]/g, '')
                this.changeDev(val)
            })
        },
        value: {
            handler(val) {
                this.devices = val
                this.imei = val
            },
            deep: true
        }
    },
    methods: {
        onSubmit() {
            let strs = this.devices.split(/\n/)
            let arr = []
            strs.forEach((item) => {
                let str = item.replace(/\s*/g, '')
                if (str.length !== 0) {
                    arr.push(str)
                }
            })
            this.onCancle()
            return arr
        },

        onCancle() {
            this.devices = ''
            this.close()
        },

        focus() {
            this.isArea = true
            document.addEventListener('mousedown', this.monitor)
            this.$nextTick(() => {
                const ref = this.$refs.areaInput
                ref.focus()
            })
        },

        clear() {
            this.devices = ''
            this.imei = ''
        },

        close() {
            this.imei = this.devices.replace(/[(\r\n)\r\n]+/g, ' ')
            this.isArea = false
            document.removeEventListener('mousedown', this.monitor)
        },



        monitor(e) {
            let el = this.$refs.area
            if (!el) return
            if (!el.contains(e.target)) {
                this.close()
            }
        },
        onChange() {
            let strs = this.devices.split(/\n/)
            let arr = []
            strs.forEach((item) => {
                let str = item.replace(/\s*/g, '')
                if (str.length !== 0) {
                    arr.push(str)
                }
            })
            this.$emit('input-change', arr)
        },
        getEffect() {
            if (this.devices === '') {
                let msg = this.$t('TS.Devices.AddImeiInput.Tips')
                this.$tips.warning(msg)
            }
            this.close()
            let strs = this.devices.split(/\n/)
            let arr = []
            strs.forEach((item) => {
                let str = item.replace(/\s*/g, '')
                if (str.length !== 0) {
                    arr.push(str)
                }
            })
            let imeis = arr.toString()
            this.$emit('add', imeis)
        },
        changeDev(val) {
            this.$emit('change', val)
        },
        successImei(val) {
            this.$emit('success', val)
        },
    }
}
</script>

<style lang="scss" scoped>
.batch-input-device {
    z-index: 1;
    position: relative;
    height: 32px;

    .btn-add {
        border-radius: 0 4px 4px 0;
    }

    .input-box {
        position: relative;
        flex: 1;

        .input-imei.circular .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right-width: 0;
        }
    }

    .add-btn {
        width: 74px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .area-bottom {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 16px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border: 1px solid #bcc4d4;
        border-top: 0;
        background-color: #fff;

        .block-btn {
            display: flex;
        }
    }

    .area-box {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
    }

    .area-bottom-focus {
        border-color: $primary-color;
    }

    .el-textarea .el-textarea__inner {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        padding: 5px 16px;
        border-bottom-color: #eceef2;
        font-family: Arial;
    }
}

.batch-input-device:hover {
    .area-bottom {
        border-color: $primary-hover-color;
    }

    .area-bottom-focus {
        border-color: $primary-color;
    }
}

.batch-input-device-hover {
    .ux-input.el-textarea .el-textarea__inner {
        border-color: $primary-hover-color;
        border-bottom-color: #eceef2;
    }
}
.batch-input-device {
    ::v-deep .el-input__inner{
    border: 1px solid #BCC4D4;
    }
}
</style>